<script setup lang="ts">
import { inject, ref } from 'vue';
import { faPen } from '@fortawesome/pro-solid-svg-icons';
import { useUserStore } from 'gpcore-apikit/store/pinia/user';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { BillingProfileInject } from '../symbols';
import EditBillingProfileAddressModal from '../EditBillingProfileAddressModal.vue';

withDefaults(defineProps<{ editable?: boolean }>(), { editable: true });

const billingProfile = inject(BillingProfileInject);
const isEditProfileModalOpened = ref(false);

const userStore = useUserStore();
const handleAddressUpdated = () => {
  userStore.reloadBillingProfiles();
  isEditProfileModalOpened.value = false;
};
</script>

<template>
  <div class="tw-mb-4 tw-flex tw-items-center tw-justify-between">
    <h3>Address</h3>

    <a v-if="editable" href="#" class="tw-ml-2" @click.prevent="isEditProfileModalOpened = true">
      <FontAwesomeIcon :icon="faPen" class="tw-mr-2 tw-text-sm" />
      <span class="tw-font-bold">Edit </span>
    </a>
  </div>

  <p class="tw-mb-2" v-if="billingProfile.company">
    <strong v-if="billingProfile">{{ billingProfile.company.name }}</strong>
    <br />
    <span class="tw-font-bold">{{ billingProfile.name }}</span>
  </p>
  <p class="tw-mb-2 tw-font-bold" v-else>{{ billingProfile.name }}</p>
  <p class="tw-mb-4">
    {{ billingProfile.street }}
    <br />
    {{ billingProfile.postcode }} {{ billingProfile.city }}
    <template v-if="billingProfile.state">
      <br />
      {{ billingProfile.state }}
    </template>
    <br />
    {{ billingProfile.countryCode }}
  </p>
  <strong>Tax</strong><br />
  <span>{{ billingProfile.taxRate }}%</span><br />

  <EditBillingProfileAddressModal
    :show="isEditProfileModalOpened"
    @updated="handleAddressUpdated"
    @close="isEditProfileModalOpened = false"
  />
</template>

<style scoped></style>
